// Central legal information used by Privacy, Mentions Légales, and CGV pages.
// Data of the legal entity operating www.pro-pre.com / www.pro-pre.fr
export const LEGAL_INFO = {
  // Identity
  entityName: "Claudio Terzi",
  legalStatus: "Entrepreneur individuel (micro-entrepreneur) — France",
  address: "28 Ter Rue Guersant, 75017 Paris",
  city: "Paris",
  country: "France",
  // French VAT — Franchise en base
  vat: "TVA non applicable, art. 293 B du CGI",
  // French business register
  rcs: "SIRET 978 548 329 00017 — APE 7022Z (Conseil de gestion) + activité secondaire déclarée : Nettoyage de textiles à domicile",

  // Contacts
  email: "contact@pro-pre.com",
  privacyEmail: "privacy@pro-pre.com",
  phone: "+32 466 13 28 39",
  whatsapp: "+32 466 13 28 39",

  // Sites & hosting
  domainPrimary: "www.pro-pre.com",
  domainSecondary: "www.pro-pre.fr",
  hostingProvider: "Emergent Cloud (Google Cloud EU — Belgium region)",
  hostingContact: "support@emergent.sh",

  // Professional insurance
  insurance: "En cours de souscription",
  insuranceNumber: "En cours de souscription (RC Professionnelle)",

  // Data processors (GDPR sub-processors)
  subProcessors: [
    { name: "Stripe Payments Europe Ltd.", purpose: "Paiement en ligne", country: "Irlande (UE)", url: "https://stripe.com/privacy" },
    { name: "Resend Inc.", purpose: "Envoi d'emails transactionnels", country: "USA (SCC + DPF)", url: "https://resend.com/legal/privacy-policy" },
    { name: "MongoDB Atlas", purpose: "Base de données", country: "UE (via Emergent Cloud)", url: "https://www.mongodb.com/legal/privacy-policy" },
    { name: "Google Cloud / Emergent", purpose: "Hébergement infrastructure", country: "UE (Belgique)", url: "https://cloud.google.com/terms/data-processing-addendum" },
    { name: "Emergent LLC", purpose: "Authentification Google, IA chatbot", country: "USA (SCC)", url: "https://emergent.sh/privacy" },
  ],

  // Retention
  retentionBookings: "3 ans après la fin du service (obligations comptables + garantie)",
  retentionContracts: "10 ans (obligation légale contrats commerciaux)",
  retentionPhotos: "3 ans (avec possibilité de suppression sur demande à tout moment)",
  retentionSessions: "7 jours",
  retentionLogs: "6 mois",

  // Data protection authorities (cross-border FR ↔ BE)
  dpaFrance: { name: "CNIL", url: "https://www.cnil.fr", label: "Commission Nationale de l'Informatique et des Libertés (France)" },
  dpaBelgium: { name: "APD-GBA", url: "https://www.autoriteprotectiondonnees.be", label: "Autorité de protection des données (Belgique)" },

  // Business
  serviceZone: "Bruxelles et sa périphérie (extension future : Paris, Bergamo)",
  competentCourt: "Tribunaux compétents du lieu de résidence du consommateur (art. 18 Règlement Bruxelles I bis)",
  applicableLaw: "Droit français pour l'entreprise ; le consommateur bénéficie en outre des dispositions impératives de la loi de sa résidence habituelle (art. 6 Règlement Rome I).",
  lastUpdate: "3 juillet 2026",
};

export default LEGAL_INFO;
